import {  useState } from 'react';
import { Form } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import { sendCode, recovery } from '../../services/serviceVivetuseguro';

const SidebarPasswordCodigo = ({errorData, mensaje, formCode, recaptchaRef, setMensaje, setSpinner, form, setErrorData, setCount, setFormCode, urlApi, codRecaptcha}) => {

    const [validarCodigo, setValidarCodigo] = useState(false)

    const handleSubmitCodigo = async (e) => {
        
        e.preventDefault();


        if (formCode.code.trim() !== "") {

            const token = await recaptchaRef.current.executeAsync();
            recaptchaRef.current.reset()
            if (!token) {
                setMensaje('Captcha inválido, actualizar web')
                return
            }

            setSpinner(true)

            let objUsuario = {
                id: formCode.id,
                code: formCode.code,
                tokenCaptcha: token
            }

            try {
                sendCode(objUsuario, urlApi).then(res => {
                    setSpinner(false)
                    if (res.codigo === 0) {
                        setMensaje("")
                        setErrorData(false)
                        setCount(3)
                    } else {
                        setValidarCodigo(true)
                    }
                })
            } catch (err) {
                setMensaje(err)
                setErrorData(true)
                setSpinner(false)
            }
        } else {
            setMensaje("Debes proporcionar un código.")
        }
    }

    const handleChangeCode = (e) => {
        setFormCode({
            ...formCode,
            [e.target.name]: e.target.value,
        })
    }
    const handleReenvio = async () => {
        const token = await recaptchaRef.current.executeAsync();
        recaptchaRef.current.reset()
        let objUsuario = {
            identificacion: form.identificacion,
            tokenCaptcha: token
        }
        try {
           const resp = await recovery(objUsuario, urlApi)
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <>
            <div className="body__login">
                <h2>Código de verificación</h2>
                <p>Ingresa tu código de verificación que se ha enviado a tu teléfono celular o correo electrónico para recuperar la contraseña.</p>
              
                <Form autoComplete="off" onSubmit={(e) => { e.preventDefault()}} className="form__modal" >
                    <div className="row justify-content-center">
                        <div className='col-12 '>
                            <input
                                type='text'
                                className={`form-control border-input ${validarCodigo&&'broder border-danger '}`}
                                id='code'
                                name='code'
                                autoComplete="off"
                                value={formCode.code}
                                onChange={handleChangeCode}
                                placeholder='Código'
                            />
                          
                            {validarCodigo&&<p className='text-danger ms-3 '>Código expirado o invalido</p>}
                        </div>
                        
                        <div style={{ textAlign: 'center' }} className='col-12 mt-3 pt-5 mb-4'>
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                size="invisible"
                                sitekey={codRecaptcha}
                            />
                            <div className='center_center h5 d-lg-none'>
                                <p>¿No recibiste el código? <a className='text-verde text-decoration-underline fw-bolder cursor ' onClick={handleReenvio} >Reenviar código</a></p>
                            </div>
                            <button className="btn__azul" onClick={handleSubmitCodigo}>VALIDAR</button>
                        </div>
                    </div>
                </Form>
                <div className=' h5 d-none d-lg-block'>
                    <p className=' text-center '>¿No recibiste el código? <a className='text-verde text-decoration-underline fw-bolder cursor ' onClick={handleReenvio} >Reenviar código</a></p>
                </div>
            </div>
        </>
    )
}

export default SidebarPasswordCodigo